import axios from "axios"
// import appConfig from "@/config/app";
import store from "@/store"
import router from "@/router"
import { getIdleMinutes, expireSession } from "@/helpers/idleSession"

let apiUrl = ""

  apiUrl = process.env.VUE_APP_API_URL

  // apiUrl = "http://localhost:3000/v2.0";
const $axios = axios.create({
  baseURL: apiUrl,
  timeout: 300000,
})

$axios.interceptors.request.use(
  (config) => {
    // inactivity sign-out is handled by helpers/idleSession
    const idleTime = getIdleMinutes()

    let authDetails = store.getters["auth/getAuthenticationDetails"]
    let authPatient = store.getters["patientPortal/getOrderCreationData"]
    let primaryLabId = store.getters["auth/getUserPrimaryLabId"]
    if (authDetails && authDetails["access_token"]) {
      config.headers["Authorization"] = authDetails["access_token"]
      config.headers["ls-lab"] = primaryLabId
    } else {
      config.headers["Authorization"] = ""
    }

    if (authPatient && authPatient["phone"]) {
      config.headers["Phone"] = authPatient["phone"]
    } else {
      config.headers["Phone"] = ""
    }

    if (idleTime >= 0) {
      config.headers["user-idle-time-in-min"] = idleTime
    } else {
      config.headers["user-idle-time-in-min"] = ""
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

$axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    let originalRequest = error.config
    let errorStatusCode = error.response && error.response.status

    // && !originalRequest._retry
    if (errorStatusCode === 401) {
      originalRequest._retry = true
      // the API's own idle check: same sign-out and notice as the idle timer
      if (error.response.data && error.response.data.errCode === "SESSION_TIMEOUT") {
        expireSession()
        return Promise.reject(error)
      }
      if (error.message == "jwt expired") {
        alert("Session Expired !")
      }
      resetStore()
      if (originalRequest && originalRequest.url !== "/signin") {
        router.push("/signin")
      }
    }
    return Promise.reject(error)
  }
)

const resetStore = () => {
  store.dispatch("globalReset")
}
export default $axios
